import { Box, Grid, Typography } from '@atgfr8/atg-ui-tailwind';
import { Button } from '@components';
import { closeModal } from '@store/modals';
import { updateLoadPropertyAtIndex } from '@store/orders';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Component } from 'solid-js';

import { isLTLModalClasses as classes } from './classes';

type IsLTLModalProps = {
  modalId: string;
};

const IsLTLLoad: Component<IsLTLModalProps> = (props: IsLTLModalProps) => {
  const changeMode = () => {
    updateLoadPropertyAtIndex({
      mode: 'LTL',
    });
    closeModal(props.modalId);
  };

  return (
    <Box style={{ 'flex-grow': 1 }}>
      <Grid container spacing={4} class="px-2 pb-2 items-center">
        <Grid item size={12} class="text-left">
          <Typography
            class={classes.titleTypography}
            variant="h6"
            component="h2"
          >
            Is LTL Load
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={4} class="px-1 mb-2">
        <Grid item size={12} class="text-left">
          <Typography variant="body1" component="div">
            Is this an LTL load?
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid
          item
          size={12}
          class={`${classes.buttonFooterGrid} flex gap-2 items-center justify-end`}
        >
          <Button
            label="Yes"
            onClick={changeMode}
            variant="contained"
            dataTestId={formatDataTestId('Yes', 'button')}
          />
          <Button
            label="No"
            onClick={() => closeModal(props.modalId)}
            variant="text"
            dataTestId={formatDataTestId('No', 'button')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IsLTLLoad;
